import $ from 'jquery';
import _size from 'lodash/size';
import 'slick-carousel';

// Toggle slider with optional ability to pass in options as parameters
export function toggleSlider(el, options = {}) {
    const $el = el instanceof jQuery ? el : $(el);
    if ($el.length) {
        if ($el.hasClass('slick-initialized')) {
            destroySlider($el);
        } else {
            buildSlider($el, options);
        }
    }
}

export function buildSlider(el, options = {}) {
    const $el = el instanceof jQuery ? el : $(el);
    const defaultOptions = {
        rows: 0, // temporary fix for slick v1.8 adding extra divs to slides breaking styles https://github.com/kenwheeler/slick/issues/3207
    };
    if ($el.length && !$el.hasClass('slick-initialized')) {
        $el.slick({ ...defaultOptions, ...options });
    }
}

export function destroySlider(el) {
    const $el = el instanceof jQuery ? el : $(el);
    if ($el.length && $el.hasClass('slick-initialized')) {
        $el.slick('unslick');
    }
}
